<div class="container-space-between">
  <app-page-title [title]="'Organisations'"></app-page-title>
</div>

<app-admin-organisations-table
  [isSaveTableState]="true"
  [isFixedBottomPaginator]="true"
></app-admin-organisations-table>
